// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.


import 'styles/components/shared/CircleOfWaiting.styl'

const CircleOfWaiting = React.createClass({
  getDefaultProps() {
    return {
      numberOfDots: 3
    }
  },

  render() {
    return (
      <div className="CircleOfWaiting">
        {_.times(this.props.numberOfDots, n => <div className="circle" key={n} style={{ animationDelay: `${ n * .2 }s` }} />)}
      </div>
    )
  }
})

export default CircleOfWaiting



// WEBPACK FOOTER //
// ./src/scripts/components/shared/CircleOfWaiting.js